import React from 'react';
import {connect} from 'react-redux';

// Components
import ScrollWrapper from 'Components/common/ScrollWrapper';
import {openNotification} from 'Actions/notification';
import Header from 'Components/common/Header';
import SearchInput from 'Components/common/SearchInput';
import BasicButton from 'Components/common/BasicButton';
import {Grid} from '@material-ui/core';
import PropTypes from 'prop-types';
import Anchor from 'Components/common/Anchor';

// Actions
import {
    getB2bPlatformList,
    updateB2bListSearchFields,
} from 'Actions/b2bManagement';
import {getStManagementList} from 'Actions/stManagement';
import {T} from 'Actions/translate';

// Icons
import {ArrowBackIos, KeyboardArrowRight} from '@material-ui/icons';
import {it} from 'date-fns/locale';

class StManagementList extends React.Component {
    pager = {
        pageNum: 0,
        pageSize: 10,
        pageTotal: 9999999999999,
    };
    state = {
        listLoaded: true,
        isBackupDialogOpened: false,
        currentId: 0,
    };

    async componentDidMount() {
        window.scrollTo(0, 0);
        const type =
            this.props.location.state && this.props.location.state.type;

        if (
            this.props.location.state &&
            this.props.location.state.currentQueryKey
        ) {
            await this.props.updateB2bListSearchFields({
                queryKey: {$set: this.props.location.state.currentQueryKey},
            });
        }
        if (type !== 'list' || type === undefined) {
            await this.props.updateB2bListSearchFields({
                queryKey: {$set: ''},
            });
        }
        this.getList();
    }

    getList = (params, flag) => {
        const {queryKey} = this.props;
        if (this.state.listLoaded === false) return;
        if (flag) {
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        this.setState({listLoaded: false});

        this.props
            .getStManagementList({
                pageNum:
                    params && params.queryKey.trim()
                        ? 1
                        : flag
                        ? 1
                        : this.pager.pageNum + 1,
                pageSize: this.pager.pageSize,
                key:
                    params && params.queryKey
                        ? params.queryKey.trim()
                        : queryKey.trim(),
            })
            .then((res) => {
                this.pager.pageNum = flag ? 1 : res.pageNum;
                this.pager.pageSize = res.pageSize;
                this.pager.pageTotal = res.pageTotal || 1;
                this.setState({listLoaded: true});
            })
            .catch((res) => {
                this.setState({listLoaded: true});
            });
    };

    onChange = (title, value) => {
        let searchParam = {
            queryKey: value,
        };

        this.props.updateB2bListSearchFields({
            [title]: {$set: value},
        });
    };

    search = () => {
        let searchParam = {
            queryKey: this.props.queryKey.trim(),
        };

        if (!this.props.queryKey || !this.props.queryKey.trim()) {
            this.pager.pageNum = 1;
        }
        this.getList(searchParam, true);
    };

    goBack = () => {
        this.props.history.push('/userCenter');
    };

    goAllApply = () => {
        this.props.history.push('/allApplyList');
    };

    gotoChangeApply = (item) => {
        console.log(item.btnStatus);
        if (item.btnStatus === 'Applied') {
            this.props.openNotification(
                T('st_management_not_repeat_apply_change'),
                'danger',
            );
        } else if (item.btnStatus === 'Edit') {
            console.log(item);
            this.props.history.push(`/stApplyChange`, {
                stItem: item,
                queryKey: this.props.queryKey,
            });
        }
    };

    render() {
        const {queryKey} = this.props;
        return (
            <div className="st-management-list-container">
                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="header-search-input">
                        <div className="header-title">
                            <div className="st-management-title">
                                {T('st_management')}
                            </div>
                            <div
                                className="st-all-apply"
                                testid="all-applications-link"
                                onClick={this.goAllApply}>
                                {'全部申请'}
                                <Anchor>
                                    <KeyboardArrowRight data-testid="keyboard-arrow-right-icon" />
                                </Anchor>
                            </div>
                        </div>
                        <SearchInput
                            title="queryKey"
                            testid="search-input"
                            defaultValue={queryKey}
                            value={queryKey}
                            placeholder={T(
                                'b2b_management_enter_st_or_subject',
                            )}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                </Header>

                <ScrollWrapper
                    listLoaded={this.state.listLoaded}
                    showAbyss={this.pager.pageNum >= this.pager.pageTotal}
                    showLoadingMore={!this.state.listLoaded}
                    getMoreData={this.getList}>
                    <ul className="st-management-list" id="stManagementUl">
                        {this.props.stManagementList.length > 0 &&
                            this.props.stManagementList.map((item, index) => (
                                <li
                                    key={index}
                                    className="st-management-item"
                                    testid="st-management-card"
                                    data-shipto={item.shipTo}>
                                    <div className="st-management-shipto-infor">
                                        <div
                                            className="left-content"
                                            testid={item.shipTo}>
                                            {item.shipTo}
                                        </div>
                                        {item.applying ? (
                                            <div className="right-content">
                                                {T(
                                                    'st_management_application_changing',
                                                )}
                                            </div>
                                        ) : null}
                                    </div>
                                    <section className="st-management-info">
                                        <div className="st-management-card">
                                            <p className="first-row">
                                                <label className="st-management-left-label">
                                                    {T('st_management_subject')}
                                                    :
                                                </label>
                                                <label className="st-management-right-content">
                                                    {item.stAlphaName
                                                        ? item.stAlphaName
                                                        : T('st_management_no')}
                                                </label>
                                            </p>
                                            <p className="second-row">
                                                <label className="st-management-left-label st-management-address">
                                                    {T(
                                                        'st_management_st_address',
                                                    )}
                                                    :
                                                </label>
                                                <label className="st-management-right-content st-management-address-content">
                                                    {item.stAddress
                                                        ? item.stAddress
                                                        : T('st_management_no')}
                                                </label>
                                            </p>
                                            <p className="row text-ellipsis">
                                                <label>
                                                    {T(
                                                        'st_management_associated_sp',
                                                    )}
                                                    :
                                                </label>{' '}
                                                <label
                                                    testid={
                                                        item.enabled === 'Y'
                                                            ? 'associated-sp-yes'
                                                            : 'associated-sp-no'
                                                    }>
                                                    {item.enabled === 'Y'
                                                        ? T(
                                                              'st_management_associated_sp_yes',
                                                          )
                                                        : T(
                                                              'st_management_associated_sp_no',
                                                          )}
                                                </label>
                                            </p>
                                            {item.actualCoveredSiteNum ? (
                                                <p className="row text-ellipsis">
                                                    <label
                                                        testid={
                                                            item.actualCoveredSiteName
                                                        }>
                                                        {T(
                                                            'st_management_current_sp',
                                                        )}
                                                        :
                                                    </label>{' '}
                                                    {item.actualCoveredSiteName}
                                                </p>
                                            ) : null}
                                        </div>
                                    </section>
                                    {item.btnStatus === 'Edit' ||
                                    item.btnStatus === 'Applied' ? (
                                        <div className="apply-change-container">
                                            <BasicButton
                                                className="st-apply-change-btn"
                                                testid="apply-change-button"
                                                type="primary"
                                                onClickOfSingleTap={() => {
                                                    this.gotoChangeApply(item);
                                                }}>
                                                {T(
                                                    'st_management_apply_change',
                                                )}
                                            </BasicButton>
                                        </div>
                                    ) : null}
                                </li>
                            ))}
                    </ul>
                </ScrollWrapper>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {userCenter, localData, b2bManagement, stManagement} = state;
    return {
        stManagementList: stManagement.stManagementList,
        backupList: userCenter.backupList,
        b2bPlatformList: b2bManagement.b2bPlatformList,
        queryKey: b2bManagement.searchfields.queryKey,
        localData,
    };
};

const mapDispatchToProps = {
    openNotification,
    getB2bPlatformList,
    updateB2bListSearchFields,
    getStManagementList,
};

StManagementList.propTypes = {
    openNotification: PropTypes.func.isRequired,
    getB2bPlatformList: PropTypes.func.isRequired,
    updateB2bListSearchFields: PropTypes.func.isRequired,
    getStManagementList: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(StManagementList);
